import { render, staticRenderFns } from "./PDK2.0.vue?vue&type=template&id=446c4a8c&"
import script from "./PDK2.0.vue?vue&type=script&lang=js&"
export * from "./PDK2.0.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports